import { useEffect, useState } from "react";
import AdminLayout from "../../layouts/AdminLayout";
import { getAllGyms } from "../../services/gymService";
import "./Revenue.css";
import { getPlans } from "../../services/subscriptionService";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function Revenue() {
  const [gyms, setGyms] = useState([]);
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const gymData = await getAllGyms();
    const planData = await getPlans();

    setGyms(gymData);
    setPlans(planData);
  };

  // const getPlanPrice = (planName) => {
  //   const plan = plans.find((p) => p.planName === planName);

  //   return Number(plan?.price || 0);
  // };

  const revenueData = plans.map((plan) => {
    const subscribers = gyms.filter(
      (gym) =>
        gym.subscriptionPlan === plan.planName &&
        gym.subscriptionDuration === plan.duration,
    ).length;

    const revenue = subscribers * Number(plan.price);

    return {
      ...plan,
      subscribers,
      revenue,
    };
  });

  const totalRevenue = revenueData.reduce((sum, plan) => sum + plan.revenue, 0);

  const basicCount = gyms.filter((g) => g.subscriptionPlan === "Basic").length;

  const standardCount = gyms.filter(
    (g) => g.subscriptionPlan === "Standard",
  ).length;

  const premiumCount = gyms.filter(
    (g) => g.subscriptionPlan === "Premium",
  ).length;

  // const totalRevenue =
  //   basicCount * getPlanPrice("Basic") +
  //   standardCount * getPlanPrice("Standard") +
  //   premiumCount * getPlanPrice("Premium");

  const downloadRevenuePDF = () => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(20);
    doc.text("NN AI Solutions", 14, 18);

    doc.setFontSize(15);
    doc.text("Revenue Analytics Report", 14, 28);

    doc.setFontSize(10);
    doc.text(`Generated On : ${new Date().toLocaleString()}`, 14, 36);

    // Summary
    doc.setFontSize(13);
    doc.text("Revenue Summary", 14, 50);

    autoTable(doc, {
      startY: 55,
      head: [["Plan", "Duration", "Subscribers", "Price", "Revenue"]],
      body: revenueData.map((plan) => [
        plan.planName,
        plan.duration,
        plan.subscribers,

        `Rs. ${Number(plan.price).toLocaleString("en-IN")}`,
        `Rs. ${Number(plan.revenue).toLocaleString("en-IN")}`,
      ]),
    });

    let y = doc.lastAutoTable.finalY + 12;

    doc.setFontSize(14);
    doc.text("Overall Statistics", 14, y);

    autoTable(doc, {
      startY: y + 5,
      body: [
        ["Total Gyms", gyms.length],
        [
          "Active Subscriptions",
          gyms.filter((g) => g.subscriptionStatus === "Active").length,
        ],
        ["Basic Subscribers", basicCount],
        ["Standard Subscribers", standardCount],
        ["Premium Subscribers", premiumCount],
        [
          "Total Revenue",
          `Rs. ${Number(totalRevenue).toLocaleString("en-IN")}`,
        ],
      ],
    });

    doc.save(`Revenue_Report_${new Date().toISOString().split("T")[0]}.pdf`);
  };

  return (
    <AdminLayout>
      <div className="revenue-container">
        <div className="revenue-header">
          <div>
            <h1>Revenue Analytics</h1>
            <p>
              Track subscription revenue and business performance across all
              gyms.
            </p>
          </div>
        </div>

        {/* Summary Cards */}

        <div className="revenue-grid">
          {revenueData.map((plan) => (
            <div className="revenue-card" key={plan.id}>
              <span>{plan.planName}</span>

              <h1>{plan.subscribers}</h1>

              <p>₹{Number(plan.price).toLocaleString()}</p>
            </div>
          ))}

          <div className="revenue-card total">
            <span>Total Revenue</span>

            <h1>₹{totalRevenue.toLocaleString()}</h1>

            <p>All Active Subscriptions</p>
          </div>
        </div>

        {/* Revenue Breakdown */}

        <div className="revenue-table-card">
          <h2>Revenue Breakdown</h2>

          <table className="revenue-table">
            <thead>
              <tr>
                <th>Plan</th>
                <th>Subscribers</th>
                <th>Price</th>
                <th>Revenue</th>
              </tr>
            </thead>

            <tbody>
              {revenueData.map((plan) => (
                <tr key={plan.id}>
                  <td>{plan.planName}</td>

                  <td>{plan.subscribers}</td>

                  <td>₹{Number(plan.price).toLocaleString()}</td>

                  <td>₹{plan.revenue.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="revenue-header">
          <div>
            <h1>Revenue Analytics</h1>
            <p>
              Track subscription revenue and business performance across all
              gyms.
            </p>
          </div>

          <button className="download-btn" onClick={downloadRevenuePDF}>
            Download PDF
          </button>
        </div>
      </div>
    </AdminLayout>
  );
}
